const features = [
  {
    icon: 'ri-book-open-line',
    title: '全本免费阅读',
    desc: '妖精漫画网所有漫画资源完全免费，无需注册登录即可畅读，真正做到零门槛享受韩漫日漫国漫的精彩内容。',
    bgClass: 'bg-primary-100',
    iconClass: 'text-primary-600',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日极速更新',
    desc: '热门连载漫画每日同步更新，下拉式阅读体验流畅顺滑，告别翻页等待，追更节奏快人一步。',
    bgClass: 'bg-accent-100',
    iconClass: 'text-accent-600',
  },
  {
    icon: 'ri-global-line',
    title: '全品类覆盖',
    desc: '韩漫日漫国漫三大品类一网打尽，奇幻魔幻恋爱题材全覆盖，妖精漫画网大全总有你喜欢的类型。',
    bgClass: 'bg-secondary-100',
    iconClass: 'text-secondary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">为什么数百万读者选择妖精漫画网在线阅读</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.title} className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60 text-center">
              <div className={`w-16 h-16 mx-auto flex items-center justify-center rounded-2xl ${f.bgClass} mb-5`}>
                <i className={`${f.icon} text-2xl ${f.iconClass}`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-3">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}